import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { submitSimCardsBatchRequest, submitSimcardsValidateBatchRequest, setStateSimcards, cleanValidatedSimcards, patchSimcardsBatchRequest } from '../../actions/simcards';
import { simCardSelector } from '../../selectors/simcards';
import CreateSimcards from './CreateSimcard';

const mapStateToProps = createStructuredSelector({
    simcards: simCardSelector
});
const mapDispatchToProps = {
    submitSimCardsBatchRequest,
    submitSimcardsValidateBatchRequest,
    setStateSimcards,
    cleanValidatedSimcards,
    patchSimcardsBatchRequest,
    
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateSimcards);